"use strict";
/*
 * This file is part of the Wrzasq.pl.
 *
 * @copyright 2016, 2019, 2024 - 2025 © by Rafał Wrzeszcz - Wrzasq.pl.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToHash = void 0;
const HASH_SIGN_POSITION = 1;
const scrollToHash = (hash) => {
    const id = hash.substring(HASH_SIGN_POSITION);
    const target = document.getElementById(id);
    if (target) {
        target.scrollIntoView({
            behavior: "smooth",
        });
    }
};
exports.scrollToHash = scrollToHash;
